import { render, staticRenderFns } from "./NoticePop.vue?vue&type=template&id=125351db"
import script from "./NoticePop.vue?vue&type=script&lang=js"
export * from "./NoticePop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('125351db')) {
      api.createRecord('125351db', component.options)
    } else {
      api.reload('125351db', component.options)
    }
    module.hot.accept("./NoticePop.vue?vue&type=template&id=125351db", function () {
      api.rerender('125351db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/NoticePop.vue"
export default component.exports